// Detects an EIP-1193 provider. Returns the correct injected object for the wallet
// the user actually clicked (Trust / MetaMask / Binance / TokenPocket / generic).

export const WALLETS = {
  TRUST:      'trust',
  METAMASK:   'metamask',
  BINANCE:    'binance',
  TOKENPOCKET:'tokenpocket',
  INJECTED:   'injected'
};

export function detectProvider(kind) {
  if (typeof window === 'undefined') return null;
  const eth = window.ethereum;

  // Trust Wallet
  if (kind === WALLETS.TRUST) {
    if (window.trustwallet) return window.trustwallet;
    if (eth && eth.isTrust) return eth;
    if (eth && eth.providers) {
      const t = eth.providers.find(p => p.isTrust || p.isTrustWallet);
      if (t) return t;
    }
    return eth || null;
  }
  // MetaMask
  if (kind === WALLETS.METAMASK) {
    if (eth && eth.providers) {
      const m = eth.providers.find(p => p.isMetaMask && !p.isTrust && !p.isBraveWallet);
      if (m) return m;
    }
    if (eth && eth.isMetaMask) return eth;
    return eth || null;
  }
  // Binance
  if (kind === WALLETS.BINANCE) {
    if (window.BinanceChain) return window.BinanceChain;
    return eth || null;
  }
  // TokenPocket
  if (kind === WALLETS.TOKENPOCKET) {
    if (window.tokenpocket && window.tokenpocket.ethereum) return window.tokenpocket.ethereum;
    if (eth && eth.isTokenPocket) return eth;
    return eth || null;
  }
  return eth || null;
}

// Best-effort check that a wallet is installed
export function hasWallet(kind) {
  if (typeof window === 'undefined') return false;
  const eth = window.ethereum;
  if (kind === WALLETS.TRUST)       return !!(window.trustwallet || (eth && (eth.isTrust || (eth.providers || []).some(p => p.isTrust))));
  if (kind === WALLETS.METAMASK)    return !!(eth && (eth.isMetaMask || (eth.providers || []).some(p => p.isMetaMask)));
  if (kind === WALLETS.BINANCE)     return !!window.BinanceChain;
  if (kind === WALLETS.TOKENPOCKET) return !!(window.tokenpocket || (eth && eth.isTokenPocket));
  return !!eth;
}

export async function requestAccounts(provider) {
  if (!provider) throw new Error('No wallet provider available.');
  const accounts = await provider.request({ method: 'eth_requestAccounts' });
  return accounts && accounts.length ? accounts[0] : null;
}
